module.exports = __webpack_public_path__ + "img/4.d883253d.png";